import React from 'react';
import { PropTypes } from 'prop-types';

import { Input, Form, Checkbox } from 'antd';

const formItemLayout = {
  labelCol: { span: 6 },
  wrapperCol: { span: 16 },
};

const TrafficWebsiteForm = ({
  form,
}) => (
  <Form
    name="basic"
    className="gx-form-row0"
    ref={form}
    {...formItemLayout}
  >
    <Form.Item
      label="Hard Ban"
      name="black_listed"
      valuePropName="checked"
    >
      <Checkbox />
    </Form.Item>
  </Form>
);

TrafficWebsiteForm.propTypes = {
  form: PropTypes.shape({
    current: PropTypes.shape({}),
  }),
};

TrafficWebsiteForm.defaultProps = {
  form: {},
};

export default TrafficWebsiteForm;
